// extracted by mini-css-extract-plugin
export var arrow = "W_9";
export var body = "W_c";
export var circle = "W_dX";
export var customer = "W_dW";
export var feedback = "W_dV";
export var feedbacks = "W_dS";
export var footer = "W_cb";
export var footerText = "W_cc";
export var left = "W_bT";
export var nameLocation = "W_dY";
export var padding = "W_dQ";
export var right = "W_cv";
export var section = "W_d";
export var selected = "W_bg";
export var selectors = "W_dR";
export var subtitle = "W_cj";
export var text = "W_b0";
export var title = "W_h";
export var wrapper = "W_dT";